import React, { forwardRef } from "react";
import { useMask } from "@react-input/mask";

export const Input = forwardRef(function Input(
  {
    value,
    onChange,
    placeholder,
    type = "text",
    className = "",
    disabled = false,
    mask,
    replacement,
    readonly = false,
    ...props
  },
  ref,
) {
  const maskRef = useMask(
    mask
      ? {
          mask,
          replacement,
        }
      : undefined,
  );

  const setRef = (node) => {
    if (typeof maskRef === "function") maskRef(node);
    else if (maskRef && "current" in maskRef) maskRef.current = node;

    if (typeof ref === "function") ref(node);
    else if (ref) ref.current = node;
  };

  return (
    <input
      ref={mask ? setRef : ref}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      readOnly={readonly}
      {...props}
    />
  );
});
